import { render, staticRenderFns } from "./OperationContainer.vue?vue&type=template&id=a2135f74&scoped=true"
import script from "./OperationContainer.vue?vue&type=script&lang=js"
export * from "./OperationContainer.vue?vue&type=script&lang=js"
import style0 from "./OperationContainer.vue?vue&type=style&index=0&id=a2135f74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2135f74",
  null
  
)

export default component.exports